// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"97db2a5f","703":"00d73f7c","787":"f7361627"}[chunkId] + ".chunk.js";
};